import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-management',
  templateUrl: './customer-management.component.html',
  styleUrls: []
})
export class CustomerManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
